export const CHECK_MEMBER_NOT_VALID_MAIL =
  'Numéro adhérent ou adresse mail invalide, Merci de vous réferer aux informations liées à votre contrat.';
export const CHECK_MEMBER_EXIST =
  "Ce numéro d'adhérent ou cet email est déjà associé à un compte";
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,100}$/;
